export const BACKEND_SERVER_ADDRESS1 = `https://api.themilkbar.co`;
export const BACKEND_SERVER_ADDRESS = `https://themilkbar.co`;
// export const BACKEND_SERVER_ADDRESS = `http://localhost:3000`;
export const GET_EVERY_PROJECT_DATA_API_ADDRESS = `${BACKEND_SERVER_ADDRESS1}/api/admin/get-projects`;
